import { useEffect, useState } from 'react'

import { usePayPalScriptReducer } from '@paypal/react-paypal-js'

export function usePayLaterFunding() {
  const [{ isResolved }] = usePayPalScriptReducer()
  const [isPayLaterFundingAvailable, setIsPayLaterFundingAvailable] = useState(false)

  useEffect(() => {
    if (!isResolved || !window.paypal?.Buttons) return

    setIsPayLaterFundingAvailable(window.paypal.Buttons({ fundingSource: window.paypal.FUNDING.PAYLATER }).isEligible())
  }, [isResolved])

  return isPayLaterFundingAvailable
}
